import { render, staticRenderFns } from "./WarrantyClaimProduct.vue?vue&type=template&id=27957525&"
import script from "./WarrantyClaimProduct.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports